module.exports = __webpack_public_path__ + "img/slider_galery_5.d9077c75.jpg";